import { CLICK_ID } from '../../../constants';

/**
 * Extracts and formats a click identifier from the provided URL values.
 *
 * @param urlValues - A record containing key-value pairs from the URL query parameters.
 *                    Expected keys include 'gclid', 'msclkid', 'fbclid', and 'awc'.
 * @param pathNamePrepared - A fallback string to return if no click identifier is found.
 *
 * @returns A formatted click identifier string based on the first matching key in urlValues,
 *          or the pathNamePrepared string if no identifiers are present.
 */
export function getClickId(urlValues: Record<string, string>, pathNamePrepared: string) {
  const { gclid, msclkid, fbclid, awc } = urlValues;

  if (gclid) {
    return `${CLICK_ID.PREFIX}gclid_${gclid}${CLICK_ID.SEPERATOR}`;
  } else if (msclkid) {
    return `${CLICK_ID.PREFIX}msclkid_${msclkid}${CLICK_ID.SEPERATOR}`;
  } else if (fbclid) {
    return `${CLICK_ID.PREFIX}fbclid_${fbclid}${CLICK_ID.SEPERATOR}`;
  } else if (awc) {
    return `${CLICK_ID.PREFIX}awc_${awc}${CLICK_ID.SEPERATOR}`;
  }

  return pathNamePrepared;
}
